import { Component, Input, inject, type AfterViewInit } from '@angular/core';
import { CONSENT_LEVEL, ConsentService } from '@core/consent';
import { WINDOW } from '@innogy/utils-dom';

import { CookieSettingsRendering } from '../../../model';
import { ConsentAnalyticsService } from '../../consent-analytics.service';
import { CookiewallService } from '../../cookiewall.service';
import { CookieSettingsComponent } from '../cookie-settings/cookie-settings.component';

@Component({
  selector: 'wl-cookie-settings-container',
  templateUrl: './cookie-settings-container.component.html',
  host: { ngSkipHydration: 'true' },
  standalone: true,
  imports: [CookieSettingsComponent],
})
export class CookieSettingsContainerComponent implements AfterViewInit {
  readonly #consentService = inject(ConsentService);
  readonly #consentAnalytics = inject(ConsentAnalyticsService);
  readonly #cookiewallService = inject(CookiewallService);
  readonly #location = inject(WINDOW)?.location;

  allowTrackingCookies = this.#consentService.allowsTrackingCookies();

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: CookieSettingsRendering;

  onCookieSettingsSubmitted(allowTrackingCookies: boolean) {
    const level = allowTrackingCookies
      ? CONSENT_LEVEL.TRACKING
      : CONSENT_LEVEL.DEFAULT;

    this.#cookiewallService.setConsentLevel(level);
    this.#consentAnalytics.sendSubmissionBeacon(level);
    /**
     * We have to force a reload due to two downstream issues:
     *
     * 1 - We handle a lot of application loading at init time, both in the repo and in adobe launch, these will
     * currently not unload without a reload.
     *
     * 2 - the `pageInfo` object in all analytics events is not updated per event, but per page navigation
     * this means that all events between changing your preferences and navigating will send the wrong `consent`
     * data to the integration layer.
     *
     */
    this.#location.reload();
  }

  ngAfterViewInit() {
    this.#consentAnalytics.sendImpressionBeacon();
  }
}
